module.exports = __webpack_public_path__ + "static/media/at01.5476d8a3.jpg";